import React, { Component } from "react"
import PropTypes from "prop-types"
import { deactivateAccount } from "apis/mymazda"
import COLOR_PALETTE from "constants/color-palette"
import { BASE_HEADING } from "constants/general-style"
import { WINDOW } from "constants/environment"
import { bindAll, onKeyPress } from "utils"
import { connect } from "react-redux"
import { actionCreators } from "store/actions/mymazda"
import { withRadium, DetectCompact } from "higher-order-components"
import { MYMAZDA_ERRORS } from "constants/errors"
import { H3, Space, Button, Modal } from "AtomicComponents"
import { AlertList } from "AtomicContainers"
import {
  WysiwygContent,
  InputText
} from "components"

const onEnter = onKeyPress(["Enter"])

class MyMazdaDeactivateAccountFlow extends Component {
  constructor() {
    super()
    this.state = {
      isFetching: false,
      errorMsg: null,
      password: ""
    }
    bindAll(
      [
        "handleDeactivateAccount"
      ],
      this
    )
  }

  handleDeactivateAccount(event) {
    if (!this.state.password) return
    this.setState({ isFetching: true, errorMsg: null })
    deactivateAccount(this.props.deactivateAccountEndpoint, this.state.password)
      .then(() => {
        this.setState({ isFetching: false })
        this.props.onClose()
        this.props.flashMessage(MYMAZDA_ERRORS.VEHICLE_DEACTIVATE_SUCCESS, "SUCCESS")
        setTimeout(() => {
          // redirect back to mymazda index page
          WINDOW.location.assign("/mymazda")
        }, 3000)
      })
      .catch(error => {
        this.setState({ isFetching: false, errorMsg: error.message })
        if (!error.message) {
          this.props.onClose()
          this.props.flashMessage(MYMAZDA_ERRORS.VEHICLE_DEACTIVATE_FAILED, "ERROR")
        }
      })
  }

  render() {
    const {
      compact,
      deactivateAccountHeading,
      deactivateAccountDescription,
      deactivateAccountButton,
      cancelDeactivateAccountButton,
      onClose
    } = this.props
    return (
      <div style={styles.slide(compact)}>
        <H3 withDetails>{deactivateAccountHeading}</H3>
        <Space />
        <Space />
        <WysiwygContent>
          <p>{deactivateAccountDescription}</p>
        </WysiwygContent>
        <form autoComplete="nope">
          <InputText
            label={"Enter your password"}
            type="password"
            autocomplete="new-password"
            name="password"
            onKeyPress={onEnter(this.handleDeactivateAccount)}
            disabled={this.state.isFetching}
            value={this.state.password}
            onChange={({ target: { value } }) => this.setState({ password: value })} />
        </form>
        <AlertList data={this.state.errorMsg} />
        <Button
          gtm={{
            category: "MyMazda - Manage Account",
            action: `DEACTIVATE ACCOUNT - Clicked "${deactivateAccountButton.toUpperCase()}"`
          }}
          disabled={!this.state.password}
          loading={this.state.isFetching}
          fullWidth
          styleName={"black"}
          onClick={this.handleDeactivateAccount} >
          {deactivateAccountButton}
        </Button>
        <Space />
        <Button
          gtm={{
            category: "MyMazda - Manage Account",
            action: `DEACTIVATE ACCOUNT - Clicked "${cancelDeactivateAccountButton.toUpperCase()}"`
          }}
          disabled={this.state.isFetching}
          fullWidth
          styleName={"blackOutlined"}
          onClick={onClose}>
          {cancelDeactivateAccountButton}
        </Button>
      </div>
    )
  }
}

const styles = {
  slide: compact => ({
    padding: compact ? "0" : "3em",
    textAlign: "center"
  }),
  backLink: {
    ...BASE_HEADING,
    display: "block",
    textAlign: "left",
    marginTop: "-2em",
    marginLeft: "-2em",
    marginBottom: "2em",
    fontSize: "80%",
    cursor: "pointer",
    color: COLOR_PALETTE.GRAY_DARK,
    transition: "color .25s",
    ":hover": {
      color: COLOR_PALETTE.GRAY_DARKER
    }
  }
}

MyMazdaDeactivateAccountFlow.propTypes = {
  gtmEvent: PropTypes.func,
  compact: PropTypes.bool,
  onClose: PropTypes.func,
  flashMessage: PropTypes.func,
  deactivateAccountEndpoint: PropTypes.string,
  deactivateAccountHeading: PropTypes.string,
  deactivateAccountDescription: PropTypes.string,
  deactivateAccountButton: PropTypes.string,
  cancelDeactivateAccountButton: PropTypes.string
}

const mapDispatchToProps = dispatch => ({
  flashMessage: (...args) => dispatch(actionCreators.addFlashMessage(...args))
})


export default withRadium(
  connect(null, mapDispatchToProps),
  DetectCompact())(props => (
  <Modal open width={"650px"} handleClose={props.onClose}>
    <MyMazdaDeactivateAccountFlow {...props} />
  </Modal>
))



// WEBPACK FOOTER //
// ./src/containers/mymazda/manage-account/deactivate-account-flow.jsx